/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popMethod.vue?vue&type=template&id=55e9be4c&scoped=true"
import script from "./popMethod.vue?vue&type=script&lang=js"
export * from "./popMethod.vue?vue&type=script&lang=js"
import style0 from "./popMethod.vue?vue&type=style&index=0&id=55e9be4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e9be4c",
  null
  
)

export default component.exports